import { OptimizelyFeatureFlags } from 'constants/optimizely'

const COMPARISON_ENABLED_AGENTS: Array<string> = [
  // CS Agents
  'c17d6095-795e-4a7c-a142-ac0c06187378',
  '354ee9ed-8ba7-4437-82ac-8cfd4850a3bb',
  '074c7c34-07ab-4fb5-b39f-560882928836',
  '90c8e354-7afb-4ad0-a4e3-9ca2073af303',
  '148b5fe4-14d6-467d-bb38-f744927a02e5',
  '3d5df476-e41c-4ae2-84b5-5cd5eba8fa40',
  'a28dab77-0c8c-4675-9408-e9010de093fa',
  'e0485ea5-c60e-4905-b7f5-c37f3b810ea7',
  '0793748-2d51-467b-b03b-cf524d1289fe',
  'a79f96c0-4d94-4736-9259-c1aebbaefc19',
  // Other employees
  '26f1e303-018f-435d-9c94-7d70662c6058',
]

export const selectCartOfferComparisonSpoofedSelections = (state: App.State) => state.cartOfferComparison.spoofedSelections

export const selectCartActiveComparison = (state: App.State) => state.cartOfferComparison.activeComparison

export const selectIsCreatingCartOfferComparison = (state: App.State) => state.cartOfferComparison.loading

export const isSpoofedOfferComparisonEnabled = (state: App.State) => state.auth.account.agentId && (COMPARISON_ENABLED_AGENTS.includes(state.auth.account.agentId) || state.system.features.flags[OptimizelyFeatureFlags.croCsCartComparison])
